export const studyReportTypes = [
   "study-genetic-report-internal",
   "gc-doc-results",
   "study-report",
   "study-report-participant",
   "study-report-hcp",
];
